import { WeeklyDigest } from '@/components/WeeklyDigest';

export default function WeeklyDigestPage() {
  return (
    <div className="space-y-4" data-testid="client-weekly-digest">
      <div>
        <div className="label-mini text-[var(--c-green-ink)]">Your Week</div>
        <h1 className="font-display font-black text-3xl mt-1">Weekly Report</h1>
        <p className="text-sm text-muted-foreground mt-1">Your scorecard across Training, Nutrition & Recovery — refreshed every Monday for the week just gone.</p>
      </div>
      <WeeklyDigest />
    </div>
  );
}
